<template>
  <div id="base_sort_bar">
    <h2 class="eplist_title">
      <span v-if="$attrs['current-subcategorynm']" class="sec_title">
        {{ $attrs['current-subcategorynm'] }}
      </span>
      <span v-else class="sec_title">{{ currentPageTitle }}</span>
    </h2>
    <div class="eplist_sort">
      <ul class="board_sort">
        <li
          v-for="sort in sortOrder"
          :key="sort.value"
          :class="{
            active: currentSortValue && currentSortValue == sort.value
          }"
        >
          <a @click="changeSortOrder(sort)">
            <span>{{ sort.text }}</span>
          </a>
        </li>
        <li class="active_bar" :style="activeBarStyle"></li>
      </ul>
    </div>
    <div class="eplist_count">
      <span class="sub_tit">({{ currentBookCount }}종)</span>
    </div>
    <div class="eplist_listype">
      <button
        type="button"
        :class="{ active: landscape }"
        class="btn_listype_max"
        @click="landscapeMode"
      >
        <svg viewBox="0 0 16 12" class="svg_listype">
          <path
            d="M1 2H15C15.2652 2 15.5196 1.89464 15.7071 1.70711C15.8946 1.51957 16 1.26522 16 1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM15 5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7H15C15.2652 7 15.5196 6.89464 15.7071 6.70711C15.8946 6.51957 16 6.26522 16 6C16 5.73478 15.8946 5.48043 15.7071 5.29289C15.5196 5.10536 15.2652 5 15 5ZM15 10H1C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10Z"
          ></path>
        </svg>
        <span class="blind">{{ $t('views.store.categorybooks.9936') }}</span>
      </button>
      <button
        type="button"
        class="btn_listype_min"
        :class="{ active: !landscape }"
        @click="normalMode"
      >
        <svg viewBox="0 0 18 18" class="svg_listype">
          <path
            d="M17 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0ZM8 16H2V10H8V16ZM8 8H2V2H8V8ZM16 16H10V10H16V16ZM16 8H10V2H16V8Z"
          ></path>
        </svg>
        <span class="blind">{{ $t('views.store.categorybooks.291') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseSortBar',
  props: {
    currentPageTitle: {
      type: String,
      default: '책리스트'
    },
    currentSortValue: {
      type: String,
      default: ''
    },
    currentBookCount: {
      type: Number,
      default: 0
    },
    landscape: {
      type: Boolean,
      default: true
    },
    getCurrentSubCategoryNm: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sortOrder: [
        {
          value: 'SA',
          text: `${this.$t('views.store.bookdetail.bypopular')}`
        },
        {
          value: 'PD',
          text: `${this.$t('views.store.bookdetail.release')}`
        }
        // 220919 오너 요청건 hjshyo
        // {
        //   value: 'MN',
        //   text: `${this.$t('views.store.bookdetail.pricelow')}`
        // },
        // {
        //   value: 'MX',
        //   text: `${this.$t('views.store.bookdetail.pricehigh')}`
        // }
        // 231212
        // {
        //   value: 'RV',
        //   text: `${this.$t('views.store.bookdetail.revieworder')}`
        // }
      ]
    }
  },
  computed: {
    activeBarStyle() {
      const idxNo = this.sortOrder.findIndex((x) => {
        return x.value === this.currentSortValue
      })
      return {
        width: `50%`,
        left: `${50 * idxNo}%`
      }
    }
  },
  methods: {
    normalMode() {
      this.$emit('changeMode', false)
      // this.landscape = false
    },
    landscapeMode() {
      this.$emit('changeMode', true)
      // this.landscape = true
    },
    changeSortOrder(sort) {
      this.$emit('sorting', sort)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
/* eplist - grid list - order */
.board_sort {
  position: relative;
  text-align: right;
}
.board_sort > li {
  position: relative;
  display: inline-block;
  min-height: 24px;
}
.board_sort > li + li {
  margin-left: 16px;
  padding-left: 16px;
}
.board_sort > li + li:before {
  position: absolute;
  content: '';
  left: -1px;
  top: 50%;
  margin-top: -4px;
  width: 1px;
  height: 8px;
  border-left: 1px solid #778899;
}
.board_sort > li a {
  font-weight: 500;
  line-height: 24px;
}
.board_sort > li a.active {
  color: #125c83;
}
.board_sort:after {
  content: '';
  display: block;
  clear: both;
}
.eplist_sort {
  position: absolute;
  display: inline-block;
  top: -32px;
  right: 0px;
}
.eplist_sort .select_list {
  width: 220px;
  top: 100%;
  margin-top: 8px;
}
.eplist_listype + .eplist_sort {
  right: 110px;
}
/* eplist - grid list - type option */
.eplist_listype .btn_listype_max,
.eplist_listype .btn_listype_min {
  float: left;
  width: 40px;
  height: 40px;
  background-color: #f0f5fa;
  margin-left: 8px;
  border-radius: 3px;
}
.eplist_listype .btn_listype_max .svg_listype,
.eplist_listype .btn_listype_min .svg_listype {
  width: 20px;
  height: 20px;
  margin: 10px;
  fill: #778899;
}
.eplist_listype .btn_listype_max.active,
.eplist_listype .btn_listype_min.active {
  background-color: #3ab7ab;
}
.eplist_listype .btn_listype_max.active .svg_listype,
.eplist_listype .btn_listype_min.active .svg_listype {
  fill: white;
}
/* eplist - grid list - option + item_list */
.eplist_listype + .item_list,
.eplist_sort + .item_list {
  margin-top: 20px;
}
#base_sort_bar {
  display: grid;
  max-width: 980px;
  margin: 0 auto 0px;
  grid-template-columns: auto auto 1fr 96px;
  grid-template-areas: 'title count sort type';
  align-items: end;
  .eplist_sort,
  .eplist_listype {
    position: static;
  }
  .eplist_sort {
    grid-area: sort;
    padding: 0 14px;
    .board_sort {
      .active {
        span {
          color: $Logo_book;
        }
      }
      > .active_bar {
        display: none;
      }
      text-align: left;
    }
  }
  .eplist_listype {
    grid-area: type;
    justify-self: end;
  }
  .eplist_title {
    grid-area: title;
  }
  .eplist_count {
    grid-area: count;
    padding: 5px;
    .sub_tit {
      margin: 10px 0 0 0;
      min-height: unset;
      line-height: 24px;
    }
  }
}
@media (max-width: 768px) {
  #base_sort_bar {
    grid-template-columns: auto 1fr 96px;
    margin: 0 0 24px;
    .eplist_sort {
      grid-row: 2/3;
      grid-column: 1/4;
      padding: 0;
      .board_sort {
        > .active_bar {
          display: block;
          position: absolute;
          bottom: 0;
          min-height: 4px;
          height: 4px;
          margin: 0;
          padding: 0;
          transition: all 0.2s;
          border-radius: 3px;
          // max-width: calc(100% / 3);
          background-color: $h_sub_point;
        }
      }
    }
    .eplist_listype {
      grid-row: 1/2;
      grid-column: 3/4;
    }
    .eplist_count {
      grid-row: 1/2;
      grid-column: 2/3;
      .sub_tit {
        margin: 0;
        min-height: unset;
        line-height: unset;
      }
    }
    .eplist_title {
      grid-row: 1/2;
      grid-column: 1/2;
    }
    .eplist_listype .btn_listype_max,
    .eplist_listype .btn_listype_min {
      width: 32px;
      height: 32px;
    }
    .eplist_listype .btn_listype_max .svg_listype,
    .eplist_listype .btn_listype_min .svg_listype {
      width: 12px;
      height: 12px;
      margin: 10px;
    }
    .board_sort {
      width: 100%;
      -webkit-display: flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;
      border-bottom: 1px solid #d6e7f1;
    }
    .board_sort li {
      flex: 1;
      text-align: center;
    }
    .board_sort li + li {
      margin-left: 0px;
      padding-left: 0px;
    }
    .board_sort > li + li:before {
      display: none;
    }
    .board_sort li a {
      display: block;
      width: 100%;
      min-height: 36px;
      font-size: 14px;
      line-height: 36px;
    }
    .board_sort li a.active {
      position: relative;
    }
    .board_sort li a.active:before {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0px;
      width: 100%;
      height: 4px;
      background-color: #36a5c2;
    }
    .board_sort li a.active span {
      position: relative;
      color: #000000;
    }
  }
}
</style>
